var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 156,
    height: 42,
    viewBox: "0 0 156 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame 2131329268"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 2131329330"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.2013 11.1731L5.54303 6.8525V23.3917L21.2657 15.0598V20.3487L7.49891 27.3139L21.2657 36.1311L21.2655 41.9895L0.625 28.1218V0L21.2013 5.21315V11.1731Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.62 11.1731V5.21315L42.1964 0V28.1112L21.5557 42V37.9363V37.8683V20.3619V15.0617L33.4421 19.2773V24.5474L26.8369 22.2502V32.6872L35.3226 27.3176L37.2707 26.0764V6.8525L21.62 11.1731Z",
    fill: "#4FD18B"
  })), /*#__PURE__*/React.createElement("g", {
    id: "E-Gates"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M65.82 27.9072V21.8692H73.9349V19.6473H65.82V14.0923H76.2456V11.822H63.1494V30.1774H76.5026V27.9072H65.82Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M75.8887 23.1735H84.6197V20.7583H75.8887V23.1735Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M95.8687 20.9997V23.0768H101.312C100.747 26.603 97.82 28.197 94.9953 28.197C91.0921 28.197 88.5757 25.4437 88.5757 20.9997C88.5757 16.6525 91.2979 13.8025 95.3035 13.8025C98.0769 13.8025 100.079 15.0584 100.953 17.4253L103.418 16.5558C102.134 13.3194 99.2067 11.5806 95.3035 11.5806C89.7054 11.5806 85.8535 15.4449 85.8535 20.9997C85.8535 26.6996 89.4484 30.419 94.944 30.419C97.6662 30.419 99.8744 29.308 101.364 27.4241L101.621 30.1775H103.624V20.9997H95.8687Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M118.263 28.0521C117.544 28.0521 117.236 27.7622 117.236 27.086V20.1786C117.236 17.232 115.028 15.4448 111.484 15.4448C108.864 15.4448 106.656 16.3626 104.961 17.9566L106.553 19.5023C107.837 18.2464 109.583 17.5218 111.381 17.5218C113.435 17.5218 114.822 18.343 114.822 19.6472C114.822 20.8548 113.846 20.9997 111.227 21.3861C108.196 21.8209 104.602 22.6421 104.602 26.1199C104.602 28.68 106.656 30.419 109.634 30.419C111.946 30.419 114 29.4046 115.13 27.9071C115.284 29.6461 116.055 30.274 117.955 30.274C118.314 30.274 118.725 30.2257 118.828 30.1774V28.0521H118.263ZM109.943 28.3901C108.196 28.3901 107.169 27.569 107.169 26.0716C107.169 23.9463 109.429 23.6081 111.586 23.27C113.281 23.0285 114.205 22.8836 114.771 22.4971V24.7191C114.771 26.6995 112.511 28.3901 109.943 28.3901Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M128.639 17.7634V15.6863H123.76V11.822H121.603L121.192 15.6863H118.162V17.7634H121.192V26.5064C121.192 29.0182 122.732 30.419 125.66 30.419C126.636 30.419 127.611 30.3223 128.639 30.0808V27.8106C127.509 28.1004 126.841 28.1487 126.071 28.1487C124.478 28.1487 123.76 27.714 123.76 26.0716V17.7634H128.639Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M131.003 23.7047H143.175C143.226 23.4632 143.226 23.2217 143.226 22.9319C143.226 18.3913 140.35 15.4448 135.934 15.4448C131.517 15.4448 128.384 18.4879 128.384 22.9319C128.384 27.2309 131.208 30.419 136.19 30.419C139.529 30.419 141.634 29.2114 142.764 27.8106L140.915 26.3131C140.094 27.4241 138.655 28.2935 136.139 28.2935C133.212 28.2935 131.312 26.5063 131.003 23.7047ZM135.934 17.5218C138.45 17.5218 140.196 19.1642 140.556 21.7726H131.055C131.465 19.1642 133.263 17.5218 135.934 17.5218Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M149.803 30.419C153.449 30.419 155.812 28.7283 155.812 26.1199C155.812 23.9463 154.323 22.7869 150.214 21.7243C147.44 21.0481 146.516 20.4684 146.516 19.454C146.516 18.2947 147.8 17.5702 149.752 17.5702C151.395 17.5702 152.833 18.1015 153.963 19.1159L155.503 17.232C153.912 16.0728 151.909 15.4448 149.854 15.4448C146.362 15.4448 144 17.1354 144 19.6472C144 21.8209 145.489 22.9802 149.495 23.9463C152.422 24.6225 153.347 25.2021 153.347 26.3131C153.347 27.569 152.062 28.2935 149.854 28.2935C147.8 28.2935 146.105 27.6656 144.821 26.458L143.332 28.1487C145.026 29.6461 147.184 30.419 149.803 30.419Z",
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo4);
export default __webpack_public_path__ + "static/media/logo4.0e935a0b8a83d5d1ef9f66816176dcf3.svg";
export { ForwardRef as ReactComponent };